module.exports = __webpack_public_path__ + "img/2014.10852e40.png";